import React, { useState, useCallback, useEffect } from 'react';
import { Button, Pagination } from 'react-bootstrap';

export default function PagingButtons(props) {
  const { pageSize, currentPage, totalPages, updatePagingInfo } = props;
  const [pagingDisplay, setPagingDisplay] = useState([]);

  const pagingSetup = useCallback(() => {
    let items = [];
    items.push(
      <Button
        key={'first'}
        variant="link"
        size="sm"
        aria-label={'First Page'}
        disabled={currentPage <= 1}
        active={1 === currentPage}
        className="pg-df-outer"
        onClick={() => {
          updatePagingInfo(pageSize, 1);
        }}
      >
        {'<<'}
      </Button>
    );
    items.push(
        <Button
          key={'previous'}
          variant="link"
          size="sm"
          aria-label={'Previous Page'}
          disabled={currentPage <= 1}
          className="pg-df-inner"
          onClick={() => {
            updatePagingInfo(pageSize, currentPage-1);
          }}
        >
          {'<'}
        </Button>
      );
    let rangeStart = 1;
    let rangeEnd = 5;
    if (totalPages > 5){
        if (currentPage > 3 && currentPage <= totalPages - 2){
            rangeStart = currentPage - 2;
            rangeEnd = currentPage + 2;
        } else if (currentPage > 3 && currentPage > totalPages - 2) {
            rangeStart = totalPages - 4;
            rangeEnd = totalPages;
        }
    } else {
      rangeEnd = totalPages;
    }
    for (let number = rangeStart; number <= rangeEnd; number++) {
      items.push(
        <Button
          key={number}
          variant="link"
          size="sm"
          aria-label={`Page ${number}`}
          aria-selected={number === currentPage}
          active={number === currentPage}
          className="pg"
          onClick={() => {
            updatePagingInfo(pageSize, number);
          }}
        >
          {number}
        </Button>
      );
    }
    items.push(
        <Button
          key={'next'}
          variant="link"
          size="sm"
          aria-label={'Next Page'}
          disabled={currentPage >= totalPages}
          className="pg-df-inner"
          onClick={() => {
            updatePagingInfo(pageSize, currentPage+1 < totalPages ? currentPage+1 : totalPages);
          }}
        >
          {'>'}
        </Button>
      );
    items.push(
      <Button
        key={'last'}
        variant="link"
        size="sm"
        aria-label={'Last Page'}
        disabled={currentPage >= totalPages}
        active={totalPages === currentPage}
        className="pg-df-outer"
        onClick={() => {
          updatePagingInfo(pageSize, totalPages);
        }}
      >
        {'>>'}
      </Button>
    );
    setPagingDisplay(items);
  }, [currentPage, pageSize, totalPages, updatePagingInfo]);

  useEffect(() => {
    pagingSetup();
  }, [pagingSetup]);

  return <Pagination>{pagingDisplay}</Pagination>;
}
